var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("WriteOff.FinanceExpensesAllocation"),
        width: "350px",
        "close-on-click-modal": false,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "100px", "label-position": "left" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("WriteOff.chargeItem") + ":" } },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "chargeItemId",
                  "select-type": _vm.TYPE_NAMES.basic_data_ChargeItem,
                  "method-params": { active: true },
                  filterable: "",
                  placeholder: _vm.$t("WriteOff.SelectChargeItem"),
                  "default-value": _vm.form.chargeItemId,
                  disabled: _vm.financeChargeShareModify
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.form.chargeItemId = p.value || 0
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("WriteOff.settleAccountsTo") + ":" } },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "accountId",
                  "select-type": _vm.TYPE_NAMES.basic_data_Company,
                  "method-params": { active: true },
                  filterable: "",
                  placeholder: _vm.$t("WriteOff.SelectAccountObject"),
                  "default-value": _vm.form.accountId,
                  disabled: _vm.financeChargeShareModify
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.form.accountId = p.value || 0
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("WriteOff.ChargingDirection") + ":" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    no: "receivable",
                    disabled: _vm.financeChargeShareModify
                  },
                  model: {
                    value: _vm.form.receivable,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "receivable", $$v)
                    },
                    expression: "form.receivable"
                  }
                },
                _vm._l(_vm.RECEIVABLE_PAYABLE_TYPES, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: _vm.$getLangColumn(item), value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.Oversea") + ":" } },
            [
              _c(
                "el-select",
                {
                  attrs: { no: "oversea" },
                  model: {
                    value: _vm.form.oversea,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "oversea", $$v)
                    },
                    expression: "form.oversea"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.internal"), value: false }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("SeaExport.overseas"), value: true }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_FinancialDate") + ":" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: { no: "accountingDate", type: "date" },
                on: { change: _vm.refreshExchageRate },
                model: {
                  value: _vm.form.accountingDate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "accountingDate", $$v)
                  },
                  expression: "form.accountingDate"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("WriteOff.currency") + ":" } },
            [
              _c("cargo-advance-select", {
                attrs: {
                  no: "currency",
                  "select-type": _vm.TYPE_NAMES.basic_data_Currency,
                  filterable: "",
                  clearable: false,
                  "default-value": _vm.form.currency
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.form.currency = p.value
                    _vm.refreshExchageRate()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("FinanceManage.charge_exchangeRate") + ":"
              }
            },
            [
              _c("num-input", {
                attrs: {
                  no: "exchangeRate",
                  precision: 8,
                  "truncated-precision": _vm.exchangeRatePrecision
                },
                model: {
                  value: _vm.form.exchangeRate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "exchangeRate", $$v)
                  },
                  expression: "form.exchangeRate"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("WriteOff.amount") + ":" } },
            [
              _c("el-input", {
                attrs: {
                  value: _vm.form.amount * (_vm.form.receivable ? -1 : 1),
                  disabled: ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.confirmHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "cancel" }, on: { click: _vm.cancleHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }